import { DomainError } from "./errors";
import { formatScaled, parseScaled } from "./decimal";

/** Dígito verificador GTIN (módulo 10, pesos 3 e 1 a partir da direita) do corpo sem o dígito. */
export function gtinCheckDigit(body: string): number {
  let sum = 0;
  for (let i = 0; i < body.length; i++) {
    const d = body.charCodeAt(body.length - 1 - i) - 48;
    sum += d * (i % 2 === 0 ? 3 : 1);
  }
  return (10 - (sum % 10)) % 10;
}

/** GTIN-8, GTIN-12 (UPC), GTIN-13 (EAN) ou GTIN-14, só dígitos e com o dígito verificador certo. */
export function isValidGtin(s: string): boolean {
  if (!/^(\d{8}|\d{12,14})$/.test(s)) return false;
  return gtinCheckDigit(s.slice(0, -1)) === Number(s[s.length - 1]);
}

/** NCM: 8 dígitos, sem pontos (a tela mostra com pontos; o XML da NF-e usa só os dígitos). */
export const isValidNcm = (s: string) => /^\d{8}$/.test(s);
/** CEST: 7 dígitos. */
export const isValidCest = (s: string) => /^\d{7}$/.test(s);

export type LengthUnit = "m" | "cm" | "mm";
/** Casas decimais de cada unidade até chegar a 1 mm. */
const LENGTH_SCALE: Record<LengthUnit, number> = { m: 3, cm: 1, mm: 0 };

function nonNegative(raw: string, scale: number, code: string): number {
  const v = parseScaled(raw, scale, code);
  if (v < 0) throw new DomainError(code, `valor negativo: ${raw}`);
  return v;
}

/** Texto na unidade escolhida → milímetros inteiros. Precisão abaixo de 1 mm é recusada (sem float). */
export const lengthToMm = (raw: string, unit: LengthUnit): number =>
  nonNegative(raw, LENGTH_SCALE[unit], "invalid_length");

export const formatLength = (mm: number, unit: LengthUnit): string => formatScaled(mm, LENGTH_SCALE[unit], 0);

/** Peso em kg com até 3 casas → gramas inteiras. */
export const weightKgToGrams = (raw: string): number => nonNegative(raw, 3, "invalid_weight");

export const formatWeightKg = (grams: number): string => formatScaled(grams, 3, 3);
